<template>
  <div class="prose prose-slate dark:prose-invert max-w-none" v-html="sanitizedHtml"></div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';

const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
});

export default defineComponent({
  name: 'MarkdownMessage',
  props: {
    content: { type: String, required: true },
  },
  setup(props) {
    const sanitizedHtml = computed(() => {
      const raw = md.render(props.content || '');
      return DOMPurify.sanitize(raw, {
        USE_PROFILES: { html: true },
      });
    });

    return { sanitizedHtml };
  },
});
</script>

